import PropTypes from 'prop-types'
import {
  progressBarColorOptions,
  progressBarSizeOptions,
  progressBarVariantOptions
} from '../constants'
import { ProgressIndicatior, ProgressRoot } from '../styled-components'

const ProgressBarBar = ({
  variant = progressBarVariantOptions.PRIMARY,
  progressBarValue,
  progressColor = null,
  backgroundColor,
  size,
  ...props
}) => {
  const defineColor = progressColor ?? progressBarColorOptions[variant]

  return (
    <ProgressRoot color={backgroundColor} size={size} {...props}>
      <ProgressIndicatior
        color={defineColor}
        style={{ transform: `translateX(-${100 - (progressBarValue || 0)}%)` }}
      />
    </ProgressRoot>
  )
}

ProgressBarBar.propTypes = {
  progressBarValue: PropTypes.number,
  progressColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  size: PropTypes.oneOf(Object.values(progressBarSizeOptions))
}

export default ProgressBarBar
